<template>
    <tr :class="value.deleted_at ? 'red lighten-5' : null">
        <td class="no-wrap">
            <v-layout align-center>
                <router-link :to="{name: 'CarShow', params: {id: value.id}}" class="car-title-cell">
                    <span v-if="value.reg_number">
                        <span class="text-uppercase">{{ value.reg_number }}</span> <br>
                        <small>{{ value.type }}</small>
                    </span>
                    <span v-else-if="value.type">{{ value.type }}</span>
                    <span v-else>(mangler)</span>
                </router-link>
                <v-spacer/>
                <short-label v-if="value.category" :short="value.category.short_name"
                             :label="value.category.name"/>
            </v-layout>
        </td>
        <td>
            {{ value.km }}
        </td>
        <td>
            <strong v-if="value.contact_name">{{ value.contact_name }}</strong><br>
            <a :href="`tel: ${value.contact_phone}`" v-if="value.contact_phone"
               class="contact-phone pt-1">
                <v-icon small class="mr-1">phone</v-icon>
                {{ value.contact_phone }}
            </a>
        </td>
        <td class="text-center">
            <v-lazy>
                <v-tooltip v-for="storage in value.current_tire_storages" right :key="storage.id">
                    <template v-slot:activator="{ on }">
                        <v-chip v-on="on" color="secondary" class="white--text">
                            <v-avatar class="mr-0">
                                <tire-type-icon small :value="storage.type"/>
                            </v-avatar>
                            <strong>{{ storage.location }}</strong>
                        </v-chip>
                    </template>

                    <span>Lagret siden {{ moment(storage.in_at).format('ll') }}</span>
                </v-tooltip>
                <em v-if="value.current_tire_storages.length === 0">Ingen</em>
            </v-lazy>
        </td>
        <td>
            <strong v-if="value.deleted_at" class="red--text">Arkivert.</strong>
            {{ value.note }}
        </td>
        <td v-if="!customerId">
            <v-lazy>
                <customer-card-popup :label="value.customer.name"
                                     :is-company="!!value.customer.is_company"
                                     :customer-id="value.customer_id" :key="value.customer_id"/>
            </v-lazy>
        </td>
        <td class="text-center">
            <v-icon color="green" v-if="value.is_leasing">check_box</v-icon>
        </td>
        <td class="text-xl-left hidden-print-only" style="width: 1px;">
            <edit-car-dialog :car-id="value.id" @save="onCarSave" v-if="customerId"/>
            <v-btn text color="primary" :to="{name: 'CarShow', params: {id: value.id}}">
                <v-icon left>directions_car</v-icon>
                Vis bil
            </v-btn>
        </td>
    </tr>
</template>

<script>
    import moment from 'moment';
    import CustomerCardPopup from '../helpers/CustomerCardPopup';
    import EditCarDialog from '../helpers/EditCarDialog';
    import ShortLabel from '../helpers/ShortLabel';
    import TireTypeIcon from '../helpers/TireTypeIcon';

    export default {
        props: {
            customerId: {},
            value: {}
        },
        components: {
            CustomerCardPopup,
            EditCarDialog,
            ShortLabel,
            TireTypeIcon
        },

        methods: {
            moment,
            onCarSave() {
                this.$emit('save');
            }
        }
    }
</script>
